import React, { FC, useCallback, useState } from 'react';
import { seamlessApiClient } from '../../api/seamlessApiClient';
import { BackButton } from '../../atomic/atoms/back-button';
import {
  analyticsClient,
  VimConnectCredentialsLoginAnalyticsEventTypes,
} from '../../logic/analytics';
import { UserType } from '../../logic/types';
import { ContactDetail, ContactDetailType } from '../../types';
import { UserWithEmail, UserWithoutEmail } from './email-cases';
import { EmailSentMessage } from './email-sent-message-new';

export interface PasswordResetFormProps {
  exitForm: () => void;
  contactDetails?: ContactDetail[];
  username: string;
  organizationId: number;
}

export const PasswordResetForm: FC<PasswordResetFormProps> = ({
  exitForm,
  contactDetails,
  username,
  organizationId,
}) => {
  const [wasRestPasswordLinkCalled, setWasRestPasswordLinkCalled] = useState(false);

  const userHasEmail = contactDetails?.find((detail) => detail.type === ContactDetailType.email);

  const onPasswordResetSubmit = useCallback(async () => {
    analyticsClient.track(
      VimConnectCredentialsLoginAnalyticsEventTypes.vimConnectCredentialsSendResetPasswordEmailButtonClicked,
      {},
    );

    await seamlessApiClient.postResetPasswordLink({
      username,
      organizationId,
      contactDetailType: ContactDetailType.email,
      userType: UserType.VimEhrUser,
    });

    setWasRestPasswordLinkCalled(true);
  }, [organizationId, username]);

  return (
    <div>
      <form name="vim-ehr-login" autoComplete="off">
        <BackButton onBack={exitForm} />
        <div className="login-form-row">
          {wasRestPasswordLinkCalled ? (
            <EmailSentMessage />
          ) : (
            <>
              {userHasEmail ? (
                <UserWithEmail
                  email={userHasEmail.hint}
                  username={username}
                  onPasswordResetSubmit={onPasswordResetSubmit}
                />
              ) : (
                <UserWithoutEmail />
              )}
            </>
          )}
        </div>
      </form>
    </div>
  );
};
